import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { RootState } from "../store/store";
import {
  clearAnalyticsUser,
  clearLoginSent,
  loginAlreadySent,
  markLoginSent,
  setAnalyticsUser,
  trackEvent,
} from "./track";

export function AnalyticsIdentitySync() {
  const user = useSelector((state: RootState) => state.user.user);
  const tenantId = useSelector((state: RootState) => state.config.tenantId);
  const hadUserRef = useRef(false);

  useEffect(() => {
    if (user?.id) {
      setAnalyticsUser(user);
      hadUserRef.current = true;
      if (!loginAlreadySent(user.id)) {
        markLoginSent(user.id);
        trackEvent("login");
      }
      return;
    }

    if (hadUserRef.current) {
      hadUserRef.current = false;
      trackEvent("logout");
      clearAnalyticsUser();
      clearLoginSent();
    }
  }, [user, tenantId]);

  return null;
}
